import { render, staticRenderFns } from "./posts_admin.vue?vue&type=template&id=f0b1af24&"
import script from "./posts_admin.vue?vue&type=script&lang=js&"
export * from "./posts_admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports